<div id="avaliacoesGraphCont">
    <div id="graphShow">
        <!--FILTER TOP-->
        <div id="filtersCont">
            <div (click)="closeGraphScreen()" class="sair">Sair dos indicadores</div>
            <div id="points">...</div>
            <div id="periodo">
                <span>Período</span>
                <mat-form-field appearance="fill">
                    <mat-label>Range data (inicial-final)</mat-label>
                    <mat-date-range-input [rangePicker]="picker">
                        <input id="dataInicial" [(ngModel)]="pageSetup.start_date" disabled matStartDate placeholder="Data inicial">
                        <input id="dataFinal" [(ngModel)]="pageSetup.end_date" (dateChange)="changeDate($event)" disabled matEndDate placeholder="Data final">
                    </mat-date-range-input>
                    <mat-datepicker-toggle title="Escolher datas" matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker  disabled="false" #picker></mat-date-range-picker>
                </mat-form-field>
            </div>
            <div id="clientes">
                <span>Clientes</span>
                <select class="selectDark">
                    <option>Avaliação e SCORE</option>
                </select>
            </div>
        </div>
        <div id="graphCont">
            <!--GRAPH DRAWN DATA-->
            <div id="graph">
                <canvas *ngIf="barChartDataL" id="npsGraph" baseChart
                    [datasets]="barChartDataL"
                    [labels]="barChartLabelsL"
                    [options]="barChartOptionsL"
                    [legend]="barChartLegendL"
                    [chartType]="barChartTypeL">
                </canvas>
                <canvas *ngIf="barChartData" baseChart
                    [datasets]="barChartData"
                    [labels]="barChartLabels"
                    [options]="barChartOptions"
                    [legend]="barChartLegend"
                    [chartType]="barChartType">
                </canvas>
            </div>
            <!--GRAPH DETAIL RIGHT-->
            <div *ngIf="graphInfo" id="graphDetail">
                <div id="graphNps">
                    <div *ngIf="graphInfo.nps > 60" [style.transform]="'rotate(' + (graphInfo.nps*1.12) + 'deg)'" class="gaugeEl">
                        <div [style.background]="'rgb(0 201 151)'" class="gaugeElCircle"></div>
                    </div>
                    <div *ngIf="graphInfo.nps > 0 && graphInfo.nps <= 60" [style.transform]="'rotate(' + (graphInfo.nps*1.12) + 'deg)'" class="gaugeEl">
                        <div [style.background]="'rgb(255 191 45)'" class="gaugeElCircle"></div>
                    </div>
                    <div *ngIf="graphInfo.nps <= 0" [style.transform]="'rotate(' + (graphInfo.nps*1.12) + 'deg)'" class="gaugeEl">
                        <div [style.background]="'rgb(255 115 115)'" class="gaugeElCircle"></div>
                    </div>
                    <img *ngIf="graphInfo.nps > 60" src="assets/img/point-meter-chart-green-big.svg" alt="" />
                    <img *ngIf="graphInfo.nps > 0 && graphInfo.nps <= 60" src="assets/img/point-meter-chart-yellow-big.svg" alt="" />
                    <img *ngIf="graphInfo.nps <= 0" src="assets/img/point-meter-chart-red-big.svg" alt="" />
                    <h4>{{graphInfo.nps}}</h4>
                    <h5 *ngIf="graphInfo.nps > 60" [style.color]="'rgb(0 201 151)'">NET PROMOTER SCORE</h5>
                    <h5 *ngIf="graphInfo.nps > 0 && graphInfo.nps <= 60" [style.color]="'rgb(255 191 45)'">NET PROMOTER SCORE</h5>
                    <h5 *ngIf="graphInfo.nps <= 0" [style.color]="'rgb(255 115 115)'">NET PROMOTER SCORE</h5>
                    <span>{{graphInfo.total_evaluation | number:'1.0-0'}} avaliações</span>
                </div>
                <div class="npsType">
                    <h5 [style.color]="'rgb(0 201 151)'">{{graphInfo.num_promoter_percent}}%</h5>
                    <span>Promotores</span>
                    <div class="npsTypeGraph">
                        <div class="npsTypeGraphBar" [style.width.%]="graphInfo.num_promoter_percent" [style.background]="'rgb(0 201 151)'"></div>
                    </div>
                </div>
                <div class="npsType">
                    <h5 [style.color]="'rgb(255 191 45)'">{{graphInfo.num_passive_percent}}%</h5>
                    <span>Passivos</span>
                    <div class="npsTypeGraph">
                        <div class="npsTypeGraphBar" [style.width.%]="graphInfo.num_passive_percent" [style.background]="'rgb(255 191 45)'"></div>
                    </div>
                </div>
                <div class="npsType">
                    <h5 [style.color]="'rgb(255 115 115)'">{{graphInfo.num_detractor_percent}}%</h5>
                    <span>Detratores</span>
                    <div class="npsTypeGraph">
                        <div class="npsTypeGraphBar" [style.width.%]="graphInfo.num_detractor_percent" [style.background]="'rgb(255 115 115)'"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div (scroll)="onScroll($event)" id="topicsAndListCont">
        <!--TOPICS-->
        <div *ngIf="topicsList" id="topics">
            <h4>Tópicos em alta</h4>
            <div *ngFor="let topic of topicsList" class="topicLine">
                <input id="{{topic.idtopico}}topic" (change)="topicsChange($event, topic.idtopico)" type="checkbox" /> <label for="{{topic.idtopico}}topic">{{topic.descricao}}</label><span>{{topic.num | number:'1.0-0'}}</span>
            </div>
            <div class="noReg" *ngIf="topicsList && topicsList.length === 0">
                Nenhum tópico encontrado.
            </div>
            <!-- <div *ngIf="topicsList.length > 0" class="showMore">Mostrar +{{topicsList.length}}</div> -->
        </div>
        <!--CUSTOMERS LIST-->
        <div *ngIf="avaliacaoList" id="list">
            <div *ngFor="let avaliacao of avaliacaoList" class="listLine">
                <div class="detail">
                    <div *ngIf="avaliacao.nota >= 9" [style.background]="'rgb(0 201 151)'" class="npsScore">{{avaliacao.nota}}</div>
                    <div *ngIf="avaliacao.nota >= 7 && avaliacao.nota <= 8" [style.background]="'rgb(255 191 45)'" class="npsScore">{{avaliacao.nota}}</div>
                    <div *ngIf="avaliacao.nota <= 6" [style.background]="'rgb(255 115 115)'" class="npsScore">{{avaliacao.nota}}</div>
                    <div class="nameMonth">
                        <h4>{{avaliacao.nome}}</h4>
                        <span *ngIf="transformDate(avaliacao.dt_cadastro) !== 0">{{transformDate(avaliacao.dt_cadastro)}} </span>
                        <span class="day" *ngIf="transformDate(avaliacao.dt_cadastro) === 0">hoje</span>
                        <span class="day" *ngIf="transformDate(avaliacao.dt_cadastro) === 1">dia</span>
                        <span class="day" *ngIf="transformDate(avaliacao.dt_cadastro) > 1">dias</span>
                    </div>
                    <p>
                        {{avaliacao.descricao}}
                    </p>
                    <div class="orderFilters">
                        <span [routerLink]="['/app/pedidos']" [queryParams]="{id: avaliacao.idpedido}">Pedidos N° {{avaliacao.idpedido}}</span>
                        <div *ngFor="let topic of avaliacao.topics" class="filters">{{topic.descricao}}</div>
                        <!-- <div (click)="topicsChange($event, topic.idtopico)" *ngFor="let topic of avaliacao.topics" class="filters">{{topic.descricao}} <span class="closeFilter">X</span></div> -->
                        <!-- <div class="includeBtn">+ Incluir tópico</div> -->
                    </div>
                </div>
                <div class="photoNps">
                    <div *ngIf="avaliacao.nps > 60" [style.transform]="'rotate(' + (avaliacao.nps*1.1) + 'deg)'" class="gaugeEl">
                        <div [style.background]="'rgb(0 201 151)'" [style.transform]="'rotate(' + -(avaliacao.nps*1.1) + 'deg)'" class="gaugeElCircle"><span>{{avaliacao.nps}}</span></div>
                    </div>
                    <div *ngIf="avaliacao.nps > 0 && avaliacao.nps <= 60" [style.transform]="'rotate(' + (avaliacao.nps*1.1) + 'deg)'" class="gaugeEl">
                        <div [style.background]="'rgb(255 191 45)'" [style.transform]="'rotate(' + -(avaliacao.nps*1.1) + 'deg)'" class="gaugeElCircle"><span>{{avaliacao.nps}}</span></div>
                    </div>
                    <div *ngIf="avaliacao.nps <= 0" [style.transform]="'rotate(' + (avaliacao.nps*1.1) + 'deg)'" class="gaugeEl">
                        <div [style.background]="'rgb(255 115 115)'" [style.transform]="'rotate(' + -(avaliacao.nps*1.1) + 'deg)'" class="gaugeElCircle"><span>{{avaliacao.nps}}</span></div>
                    </div>
                    <img *ngIf="avaliacao.nps > 60" src="assets/img/point-meter-chart-green-empty.svg" alt="" />
                    <img *ngIf="avaliacao.nps > 0 && avaliacao.nps <= 60" src="assets/img/point-meter-chart-yellow-empty.svg" alt="" />
                    <img *ngIf="avaliacao.nps <= 0" src="assets/img/point-meter-chart-red-empty.svg" alt="" />
                    <div class="photo">
                        <span *ngIf="!avaliacao.photo">{{avaliacao.nome.charAt(0).toUpperCase()}}</span>
                        <img *ngIf="avaliacao.photo" src="{{avaliacao.photo}}" alt=""/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
